export { default } from './FAQs';
export * from './FAQs';
export { default as FlexibleColumnFAQs } from './FlexibleColumnFAQs';
